import { gameInfoType } from '@op/types/common';
import { getFilterDefaultDay } from '@op/utils/time';

export const isDune = ({
  gameInfo,
  replace,
  current,
}: {
  gameInfo: gameInfoType;
  replace: any;
  current: any;
}) => {
  if (gameInfo.edition_unified_id === 'e76337e746e1f95fdbf7e23c26010e448') {
    return replace;
  }

  return current;
};

export enum PAGE_NAME {
  PERFORMANCE = 'Performance',
  HERO = 'Hero',
  NIKKE = 'Nikke',
  HOT_EVENT = 'Hot Event',
  TOPIC_TRACKING = 'Topic Tracking',
  STEAM_RATINGS = 'Steam Ratings',
  REALTIME_RATINGS = 'Realtime Ratings',
  INSIGHTS = 'Insights',
  GAME_STORE = 'Game Store',
  NEWS = 'News',
  BRAND_OVERVIEW = 'Brand Overview',
  BRAND_CREATOR_LIST = 'Brand Creator List',
  GENRE_CREATOR_LIST = 'Genre Creator List',
  CHANNEL = 'Channel',
  VERSION = 'Version',
  KEYWORD = 'Keyword',
  LANGUAGE = 'Language',
  REGION_COUNTRY = 'Region/Country',
  TOPIC = 'Topic',
  COMPARE = 'Compare',
  COMPETITOR = 'Competitor',
  TRENDING_PUBLICATIONS = 'Trending Publications',
  HASHTAG = 'Hashtag',
  COMPARE_KEY_METRICS = 'Compare Key Metrics',
  KEY_METRICS = 'Key Metrics',
  KEY_OPINIONS = 'Key Opinions AI Analysis',
  KEYWORD_ANALYSIS = 'Keyword Analysis',
  AI_TOPIC_ANALYSIS = 'AI Topic Analysis',
  URL_ANALYSIS = 'URL Analysis',
  VOICE_REPORTING_TEXT_ANALYSIS = 'Voice Reporting Text Analysis',
  FEEDS = 'Feeds',
  REALTIME_OPINIONS = 'Key Metrics (Real-time)',
  REALTIME_STREAMING = 'Real-time Streaming',
  OFFICIAL_ACCOUNTS_PERFORMANCE = 'Official Accounts Performance',
  VERSION_PERFORMANCE = 'Version Performance',
  CONFIGURATION = 'Configuration',
  OVERVIEW = 'Overview',
  WEEKLY_REPORT = 'Weekly Report',
  SECURITY_WEEKLY_REPORT = 'Security-Related Mentions Weekly Report',
  ADS_OVERVIEW = 'Ad Delivery Overview',
  EVENT_DETAILS = 'Comment Details',
}

// /global/page_source_rule 接口提供
export const ExcludeFilterSourceMap: { [key: string]: string } = {
  sentiment: 'sentiment',
  sentiment_clause: 'sentimentClause',
};

// /global/page_source_rule 接口提供
export const IncludeFilterSourceMap: { [key: string]: string } = {
  in_sentiment_clause: 'sentimentClause',
  in_key_kol: 'keyKol',
};

export const ExcludeGuideSourceMap: { [key: string]: string } = {
  Guide_Overview: 'overview',
  Guide_Competitor: 'competitor',
};

export const currentDayPagesConfig: any = {
  e11000000315: getFilterDefaultDay(0, 0),
  e11000000311: getFilterDefaultDay(0, 0),
  u00451b3c0d1ca31cb29eec710f659018: getFilterDefaultDay(0, 0),
  e7f672beaa5fddd166df98bc046ba4bd4: getFilterDefaultDay(0, 0),
  e76337e746e1f95fdbf7e23c26010e448: getFilterDefaultDay(0, 0),
};

export const idKeyNameMap: any = {
  menu: 'menu_id',
  page: 'page_id',
};


export const GAME_LIST_URL = '/opinion/gamelist';

/** 从详情页返回时 sessionStorage 标记 key（按 gameId 区分），供上游页面判断是否恢复定位 */
export const getViaDetailFlagKey = (gameId: string) => `trendingPublications_viaDetail_${gameId}`;